import { Comment } from '../../store/comment';
import { Seo } from '../../types/seo';

import { DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate } from '../fetch';
import { CategoryShort, CategoryById } from './categories';
import { FileData } from './files';
import { Question } from './questions';

export interface SubCategoryShort {
  id: string;
  isActive: boolean;
  header: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  seo: Seo;
  slug: string;
}

export interface SubCategory extends SubCategoryShort {
  category: CategoryShort;
}

export interface SubCategoriesGetParams extends PagingParams {
  orderByColumn?: 'name';
  categoryIds: string[];
}

export const useSubCategoriesGet = (): FetchGet<
  PagingDataResponse<SubCategory>,
  SubCategoriesGetParams
> => useFetchGet(
  'admin/sub-categories',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export interface SubCategoryById extends SubCategoryShort {
  category: CategoryById;
  file: FileData;
  comments: Comment[]
  questions: Question[]
}

export const useSubCategoryGetById = (categoryId?: string): FetchGet<
  SubCategoryById
> => useFetchGetId(
  'admin/sub-categories',
  categoryId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export interface SubCategoryCreateResponse {
  isActive: boolean;
  name: string;
  header: string;
  description: string;
  fileId: string;
}

export interface SubCategoryCreateData {
  id: string;
}

export const useSubCategoryCreate = (): FetchCreate<
  SubCategoryCreateResponse,
  DefaultFetchError,
  SubCategoryCreateData
> => useFetchCreate(
  'admin/sub-categories',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export interface SubCategoryUpdateResponse extends SubCategoryCreateResponse {
  categoryId: string;
}

export type SubCategoryUpdateData = Partial<SubCategoryCreateData>;

export const useSubCategoryUpdate = (
  subCategoryId?: string,
): FetchUpdate<
  SubCategoryUpdateResponse,
  DefaultFetchError,
  SubCategoryUpdateData
> => useFetchUpdate(
  'admin/sub-categories',
  subCategoryId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export const useSubCategoryDelete = (subCategoryId?: string): FetchDelete => useFetchDelete(
  'admin/sub-categories',
  subCategoryId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export default {
  useSubCategoriesGet,
  useSubCategoryGetById,
  useSubCategoryCreate,
  useSubCategoryUpdate,
};
